import { render } from "./notas-visual-professor.vue?vue&type=template&id=042646d9&scoped=true"
import script from "./notas-visual-professor.vue?vue&type=script&lang=js"
export * from "./notas-visual-professor.vue?vue&type=script&lang=js"

import "./notas-visual-professor.vue?vue&type=style&index=0&id=042646d9&lang=css"
import "./notas-visual-professor.vue?vue&type=style&index=1&id=042646d9&lang=scss&scoped=true"
import "./notas-visual-professor.vue?vue&type=style&index=2&id=042646d9&scoped=true&lang=css"
import "./notas-visual-professor.vue?vue&type=style&index=3&id=042646d9&scoped=true&lang=css"

import exportComponent from "/opt/buildhome/repo/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-042646d9"]])

export default __exports__